import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class HistoricalService {
    // eslint-disable-next-line
    constructor(http) {
        this.http = http;
    }
    getHistory(analysisData) {
        const paramsQuery = this.checkQuery(analysisData);
        return this.http.get(environment.api.base + 'efas/history' + paramsQuery);
    }
    checkQuery(data) {
        let query = '?';
        if (data && data.reviewDateRange && data.reviewDateRange.length > 0) {
            query += 'initDate=' + data.initDate + '&endDate=' + data.endDate + '&';
        }
        if (data.country) {
            query += 'country=' + data.country.replace('&', '%26') + '&';
        }
        if (data.operationNumber) {
            query += 'operationNumber=' + data.operationNumber + '&';
        }
        if (data.externalAuditor) {
            query += 'externalAuditor=' + data.externalAuditor.replace('&', '%26') + '&';
        }
        if (data.executingAgency) {
            query += 'executingAgency=' + data.executingAgency.replace('&', '%26') + '&';
        }
        if (data.user) {
            query += 'user=' + data.user.replace('&', '%26') + '&';
        }
        query = query.substring(0, query.length - 1);
        return query;
    }
}
HistoricalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HistoricalService_Factory() { return new HistoricalService(i0.ɵɵinject(i1.HttpClient)); }, token: HistoricalService, providedIn: "root" });
